module.exports = "<div class=\"disabled\" style=\"padding-left: 3rem;\">\n\t<h2>My Dashboard - N/A i Alpha</h2>\n\t<p>(also serves as a fallback for undefined/unfinished routes)</p>\n</div>\n\n<router-outlet></router-outlet> <!-- needs this, as we use child routes in app-routing.module.ts -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main